export default "__VITE_ASSET__9f5d88dc__"